import React, { Fragment, useEffect, useMemo, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { clearErrorAction, allProductToWishListActionForAdmin } from '../redux/actions/wishListAction'
import swal from 'sweetalert';
import EditIcon from '@material-ui/icons/Edit'
import Loader from '../layout/loader'
import Sidebar from './Sidebar'
import './allProductByAdmin.css'




function AllWishlistProducts() {

  const history = useHistory();
  const dispatch = useDispatch();

  const { loading, error, wishListProducts } = useSelector((state) => state.wishListAllAdmin)
  const [searchTerm, setSearchTerm] = useState('');


  useEffect(() => {
    if (error) {
      swal({
        title: "Validation Error",
        text: error,
        icon: "error",
      })
      dispatch(clearErrorAction())

    }


    dispatch(allProductToWishListActionForAdmin())

  }, [dispatch, error, history])

  const rows = useMemo(() => {
    const items = wishListProducts || [];
    const normalizedSearch = searchTerm.trim().toLowerCase();

    return items
      .map((item) => ({
        id: item._id,
        productName: item.name || 'Unnamed product',
        productPrice: item.price || 0,
        userId: item.user || 'No user',
        productId: item.product || 'No product',
      }))
      .filter((item) => {
        if (!normalizedSearch) {
          return true;
        }

        return [
          item.id,
          item.productName,
          item.productPrice,
          item.userId,
          item.productId,
        ].join(' ').toLowerCase().includes(normalizedSearch);
      });
  }, [searchTerm, wishListProducts]);

  const uniqueProducts = useMemo(() => {
    return new Set((wishListProducts || []).map((item) => item.product).filter(Boolean)).size;
  }, [wishListProducts]);

  const uniqueUsers = useMemo(() => {
    return new Set((wishListProducts || []).map((item) => item.user).filter(Boolean)).size;
  }, [wishListProducts]);

  const topPrice = useMemo(() => {
    const prices = (wishListProducts || []).map((item) => Number(item.price) || 0);
    return prices.length ? Math.max(...prices) : 0;
  }, [wishListProducts]);


  return (
    <Fragment>
      {/* {deletedLoading ? <Loader /> : (<Fragment> */}
      {loading ? <Loader /> : <Fragment>
        <div className="dashboard-container">
          <Sidebar />
          <div className="productListContainer admin-wishlist-page">
            <div className='admin-list-hero admin-wishlist-hero'>
              <div>
                <span className="admin-hero-kicker">Customer demand</span>
                <h1>Wishlist products</h1>
                <p>See products customers are saving and use it as demand signal.</p>
              </div>
              <div className="admin-wishlist-hero-stats">
                <div>
                  <span>Total saves</span>
                  <strong>{wishListProducts?.length || 0}</strong>
                </div>
                <div>
                  <span>Unique products</span>
                  <strong>{uniqueProducts}</strong>
                </div>
              </div>
            </div>
            <div className="admin-wishlist-toolbar">
              <input
                type="search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search product, wishlist id, user id..."
              />
              <div className="admin-wishlist-summary-card">
                <span>Customers</span>
                <strong>{uniqueUsers}</strong>
              </div>
              <div className="admin-wishlist-summary-card">
                <span>Highest price</span>
                <strong>₹{topPrice}</strong>
              </div>
              <div className="admin-wishlist-summary-card">
                <span>Showing</span>
                <strong>{rows.length}</strong>
              </div>
            </div>

            <div className="admin-wishlist-table-card">
              {rows.length ? (
                <div className="admin-wishlist-table-scroll">
                  <table className="admin-wishlist-table">
                    <thead>
                      <tr>
                        <th>Wishlist</th>
                        <th>Product</th>
                        <th>Price</th>
                        <th>Customer</th>
                        <th>Product ID</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rows.map((item) => (
                        <tr key={item.id}>
                          <td data-label="Wishlist">
                            <strong className="admin-wishlist-id">{item.id}</strong>
                          </td>
                          <td data-label="Product">
                            <strong className="admin-wishlist-product">{item.productName}</strong>
                            <span>Saved product</span>
                          </td>
                          <td data-label="Price">
                            <strong className="admin-wishlist-price">₹{item.productPrice}</strong>
                          </td>
                          <td data-label="Customer">
                            <strong className="admin-wishlist-id">{item.userId}</strong>
                          </td>
                          <td data-label="Product ID">
                            <strong className="admin-wishlist-id">{item.productId}</strong>
                          </td>
                          <td data-label="Action">
                            <Link
                              to={`/Admin/dashboard/UpdateProduct/${item.productId}`}
                              className="admin-wishlist-action-button"
                            >
                              <EditIcon />
                              Edit
                            </Link>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="admin-wishlist-empty">
                  <strong>No wishlist products found</strong>
                  <span>Try changing the search keyword.</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </Fragment>}
      {/* </Fragment>)} */}

    </Fragment>
  )
}

export default AllWishlistProducts
